import { useState } from 'react';
import { Stack, Tabs, Banner, type TabItem } from '../../ui';
import { ChannelsTab } from './ChannelsTab';
import { TemplatesTab } from './TemplatesTab';
import { TimingTab } from './TimingTab';
import { SuppressionsTab } from './SuppressionsTab';
import { DeliveryLogTab } from './DeliveryLogTab';

/**
 * Admin -> Notifications. One console for the saleroom notification pipeline:
 * which events send on which channel, the message copy, the timing, the
 * never-contact lists, the delivery log, and the smoke tester. Everything reads
 * and writes through the authed supabase client (admin/developer RLS); changes
 * take effect on the next dispatch tick (<= 1 min), no deploy.
 */

type NotifTab = 'channels' | 'templates' | 'timing' | 'suppressions' | 'log';

const TABS: TabItem<NotifTab>[] = [
  { value: 'channels', label: 'Events & channels' },
  { value: 'templates', label: 'Templates' },
  { value: 'timing', label: 'Timing' },
  { value: 'suppressions', label: 'Suppressions' },
  { value: 'log', label: 'Delivery log' },
];

export function NotificationsSection() {
  const [tab, setTab] = useState<NotifTab>('channels');

  return (
    <Stack gap="group">
      <Banner tone="info" title="Email is live once Resend is configured; SMS delivers only after the Telnyx number is verified.">
        Changes you make here apply to new notifications within a minute - no deploy needed.
      </Banner>

      <Tabs
        variant="segmented"
        items={TABS}
        value={tab}
        onChange={setTab}
        aria-label="Notification settings"
        className="flex-wrap"
      />

      <div>
        {tab === 'channels' && <ChannelsTab />}
        {tab === 'templates' && <TemplatesTab />}
        {tab === 'timing' && <TimingTab />}
        {tab === 'suppressions' && <SuppressionsTab />}
        {tab === 'log' && <DeliveryLogTab />}
      </div>
    </Stack>
  );
}
